import { render, staticRenderFns } from "./RecipeReviewer.vue?vue&type=template&id=8767c8ea"
import script from "./RecipeReviewer.vue?vue&type=script&lang=js"
export * from "./RecipeReviewer.vue?vue&type=script&lang=js"
import style0 from "./RecipeReviewer.vue?vue&type=style&index=0&id=8767c8ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports